angular.module('impactx').config([
    '$mdDateLocaleProvider',
    '$provide',
    '$configProvider',
    function($mdDateLocaleProvider, $provide, $config) {

        $provide.value('$dateProvider', $mdDateLocaleProvider);

        /**
         *
         * @param $configObj
         * @returns {*}
         */
        function prepareDateFormat($configObj) {
            var dateFormat;

            if($configObj && $configObj.getDateFormat) {
                dateFormat = $configObj.getDateFormat();

                //We need to assign some format, otherwise $config may have no valid value and formatting is wrong.
                //Just try it: comment it out, and reload a page having some date values.
                if(dateFormat && dateFormat.length > 2) {
                    return dateFormat;
                }
            }

            //for undefined use the german one date format
            return "DD.MM.YYYY";
        }

        $mdDateLocaleProvider.formatDate = function(date) {
            var dateFormat,
                dateObj = moment(date);

            if(!dateObj.isValid()) {
                return '';
            }

            dateFormat = prepareDateFormat($config);

            return dateObj.format(dateFormat);
        };
        $mdDateLocaleProvider.parseDate = function(dateString) {
            var result,
                dateFormat = prepareDateFormat($config);

            result = moment(dateString, dateFormat, true);

            return result.isValid() ? result.toDate() : new Date(NaN);
        };
        //set default
        $mdDateLocaleProvider.firstDayOfWeek = 1;
    }]);